/* DEEN cart drawer: Dawn drawer behaviour, rendered from the DEEN cart section (header group). */
function deenCartSectionId() {
  var d = document.querySelector('cart-drawer');
  return d ? d.getAttribute('data-section-id') : null;
}
/* Locale-aware root ("/" or "/ar/") so the drawer re-renders in the visitor's language. */
function deenRoot() {
  var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return r.charAt(r.length - 1) === '/' ? r : r + '/';
}
function deenInitUpsells() {
  if (typeof window.deenUpsellsInit === 'function') window.deenUpsellsInit();
  if (typeof window.deenSyncUpsellArrows === 'function') window.deenSyncUpsellArrows();
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindOverlay();
    this.setHeaderCartIconAccessibility();
  }

  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add('animate', 'active');
      deenInitUpsells();
    });
    this.addEventListener(
      'transitionend',
      () => {
        const container = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (container && focusElement) trapFocus(container, focusElement);
      },
      { once: true }
    );
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState, keepClosed) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    this.classList.toggle('is-empty', !!this.querySelector('.deen-cart__empty'));
    deenInitUpsells();
    if (window.deenCartTimerTick) window.deenCartTimerTick();
    setTimeout(() => {
      this.bindOverlay();
      if (!keepClosed) this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: deenCartSectionId(), selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: deenCartSectionId(), selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }

  onCartUpdate() {
    var id = deenCartSectionId();
    if (!id) return;
    return fetch(deenRoot() + '?sections=' + encodeURIComponent(id) + ',cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.renderContents({ sections: sections }, true);
      })
      .catch(function () {});
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
document.addEventListener('DOMContentLoaded', deenInitUpsells);

/* Re-render and open the drawer after anything adds to the cart (product page, upsells, bundles). */
(function () {
  var timer;
  function refresh() {
    var drawer = document.querySelector('cart-drawer');
    var id = deenCartSectionId();
    if (!drawer || !id) return;
    fetch(deenRoot() + '?sections=' + encodeURIComponent(id) + ',cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) { drawer.renderContents({ sections: sections }); })
      .catch(function () {});
  }
  window.deenCartRefresh = refresh;
  var original = window.fetch;
  if (typeof original !== 'function') return;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : input && input.url;
    var p = original.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/add/.test(url)) {
      p.then(function (res) {
        if (res && res.ok) { clearTimeout(timer); timer = setTimeout(refresh, 250); }
      }).catch(function () {});
    }
    return p;
  };
})();

/* Upsell slider arrows (event delegation, survives drawer re-renders). */
(function () {
  function sync(w) {
    var r = w.querySelector('.deen-upsell__row');
    if (!r) return;
    w.setAttribute('data-start', r.scrollLeft <= 2 ? '1' : '0');
    w.setAttribute('data-end', r.scrollLeft >= r.scrollWidth - r.clientWidth - 2 ? '1' : '0');
  }
  window.deenSyncUpsellArrows = function () {
    document.querySelectorAll('.deen-cart__ups').forEach(sync);
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-ups-arrow]') : null;
    if (!b) return;
    var w = b.closest('.deen-cart__ups');
    var r = w && w.querySelector('.deen-upsell__row');
    if (!r) return;
    var card = r.querySelector('.deen-upsell__card');
    var step = card ? card.offsetWidth + 12 : r.clientWidth;
    r.scrollBy({ left: step * Number(b.getAttribute('data-ups-arrow')), behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('deen-upsell__row')) {
      var w = t.closest('.deen-cart__ups');
      if (w) sync(w);
    }
  }, true);
})();

/* Cart reservation countdown: runs per browser, restarts when it reaches zero, resets when the cart is empty. */
(function () {
  var KEY = 'deen_cart_timer_end';
  function fmt(s) {
    var m = Math.floor(s / 60), x = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (x < 10 ? '0' : '') + x;
  }
  function tick() {
    var els = document.querySelectorAll('[data-deen-timer]');
    if (!els.length) {
      if (document.querySelector('cart-drawer')) { try { localStorage.removeItem(KEY); } catch (e) {} }
      return;
    }
    var mins = Number(els[0].getAttribute('data-minutes')) || 10;
    var now = Date.now();
    var end = 0;
    try { end = Number(localStorage.getItem(KEY)) || 0; } catch (e) {}
    if (!end || end <= now || end - now > mins * 60000) {
      end = now + mins * 60000;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    var left = Math.max(0, Math.round((end - now) / 1000));
    els.forEach(function (el) {
      var t = el.querySelector('[data-deen-time]');
      if (t) t.textContent = fmt(left);
    });
  }
  window.deenCartTimerTick = tick;
  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);
})();
